import {AuthService} from "./AuthService";

// Every response carries both the key and whether API access is enabled for the
// account. The panel cannot work the latter out on its own: during admin
// impersonation the cached user is the customer, whose is_admin is false, while
// the backend still sees an admin driving the session.
export class ApiKeyService {
    url = `api_key/`;

    getApiKey() {
        return AuthService.apiGet(this.url).then(res => res.data);
    }

    generateApiKey() {
        return AuthService.apiPost(this.url + 'generate/', {}).then(res => res.data);
    }

    revokeApiKey() {
        return AuthService.apiDelete(this.url + 'revoke/').then(res => res.data);
    }
}
